// extracted by mini-css-extract-plugin
module.exports = {"textTip":"index_textTip__3KhWE"};